import { VehicleOption, DataLoadingStatus, MaxiTaxiLookUpType, MaxiTaxiSeaterInfoPayload, AsyncLoadState, FareRequestInput, ApiVehicleOption, TaxiServiceId } from "./ConditionEntities";
import services from '../../../utils/service-vehicles/ServiceMetadata';
import { Vehicle } from "../../../Services/MakeBookingContracts";
import { FeatureFlags } from "../../../Config/FeatureFlags";

/** Redux state slice for the Conditions / VehicleOptions data */
export interface ConditionState {
    SelectedCondition: VehicleOption,

    /** This will be an empty array when the condition data hasn't been loaded. */
    ConditionList: VehicleOption[],
    MaxiTaxiLookUp: MaxiTaxiLookUpType
    MaxiTaxiSeaterInfo: MaxiTaxiSeaterInfoPayload,

    /** True when the user has entered vehicle selection mode. It will trigger the Vehicle picker UI to show.  */
    IsVehicleSelectionActive: boolean;

    /** 
     * Tracks the Condition load API call progress. The number is the Suburb ID used to run the query. 
     * This is applicable for only V1 (Booking API)  
    */
    LoadingStatus: AsyncLoadState<number>;

    /** Tracks the Get Fare API call progress  */
    FareLoadStatus: AsyncLoadState<FareRequestInput>;

    /** 
     *  Contains the entire list of conditions for the selected suburb.
     *  This seems to be a workaround for a known issue with the V1 API.
     *  One API endpoint would include the Parcel condition, while another would not. This is the raw, unfiltered data.
     */
    AllRawV1Data: ApiVehicleOption[];

    /** 
     *  True when the fixed fare (aka Price Guarantee) option is available.
     *  This data comes from the API as part of the fare estimate.
     */
    IsFixedFareAvailable: boolean;

    /** When true, opens the popup to display more info about selected service. */
    ShowServiceInfo: boolean;

    /** Service to display more info about. */
    ActiveService?: VehicleOption;

    /** True when the user has checked the price guarantee toggle to display fixed fare. */
    IsPriceGuaranteeSelected: boolean;
    AllVehicles: Vehicle[];
}

/** Initial value of the selected condition */
export const InitVehicleState: VehicleOption = {    
    Service: services.any,
    // Include ApiVehicle for V2 API compatibility (maps NextAvailable to TaxiServiceId 1)
    ApiVehicle: FeatureFlags.BookingApiV2 ? {
        ApiVersion: 2,
        ApiId: TaxiServiceId.NextAvailable,  // NextAvailable TaxiServiceId
        Name: "NextAvailable",
        MaxSeat: 4,
        Description: "Next available"
    } : undefined
};

/** Initial value of the condition container */
export const InitConditionContainerState: ConditionState = {   
    SelectedCondition: InitVehicleState,
    ConditionList: [],
    MaxiTaxiLookUp: [],
    MaxiTaxiSeaterInfo: { Minimum: 0, Average: 0, Maximum: 0 },
    IsVehicleSelectionActive: false,
    LoadingStatus: {
        Status: DataLoadingStatus.Idle,
        LastInput: null,
    },
    FareLoadStatus: {
        Status: DataLoadingStatus.Idle,
        LastInput: null,
    },
    AllRawV1Data: [],
    ShowServiceInfo: false,
    IsFixedFareAvailable: false,
    IsPriceGuaranteeSelected: true,
    AllVehicles: []
};
